export const ORG_ID = 'F125391E-0B11-DF11-B472-0025B322D9D8';

export const RECIP_STATUS = {
  OPEN: '91B73580-7DC7-E011-87D5-0025B322D9D8',
  IMPLANTED: '100000003',
  PREGNANT: '100000001',
  HEAT_NOT_USED: '100000002',
} as const;

export const PROC_CODE = {
  PREGNANCY_CHECK: '7122D1F1-C2F8-E011-B8FA-000C2936192C',
  IMPLANT: 'implant',
  CIDR: 'cidr',
  HEAT_NOT_USED: 'hnu',
} as const;

export const IMPLANT_STATUS = {
  OPEN: 100000000,
  IMPLANTED: 100000003,
  PREGNANT: 100000001,
} as const;

export const PC_RESULT = {
  OPEN: 100000000,
  PREGNANT: 100000001,
} as const;

export const TIME_OF_DAY = {
  AM: 100000000,
  PM: 100000001,
} as const;

export const DEFAULT_OWNER_ID = 'F8D753F8-5EAD-E011-9DAC-0018FE7830B4';
export const SYSTEM_USER_ID = '54ABB624-0B11-DF11-B472-0025B322D9D8';

export const CHUTE_OPTIONS = [
  { label: 'Chute 1', value: 1 },
  { label: 'Chute 2', value: 2 },
] as const;

export const TRANSFER_QUALITY_OPTIONS = [
  { label: '1 - Easy', value: 1 },
  { label: '2 - Moderate', value: 2 },
  { label: '3 - Difficult', value: 3 },
] as const;

export const TRANSFER_DISTANCE_OPTIONS = [
  { label: '1 - Short', value: 1 },
  { label: '2 - Medium', value: 2 },
  { label: '3 - Long', value: 3 },
] as const;
